// src/config/config.js
// Centralized configuration file for the Forza frontend
import { resolveApiBaseUrl } from './apiUrl';

// Determine the environment
const environment = process.env.NODE_ENV || 'development';

// Define configuration based on environment
const config = {
  environment,
  
  // API Configuration
  api: {
    baseUrl: resolveApiBaseUrl({ environment }),
    usersEndpoint: '/users',
    dataEndpoint: '/data',
    socialEndpoint: '/social',
    agentEndpoint: '/agent'
  },

  // NEW: ImageKit Configuration
  imagekit: {
    urlEndpoint: process.env.REACT_APP_IMAGEKIT_URLENDPOINT || "https://ik.imagekit.io/F0rz42025/"
  },

  media: {
    workerBase: process.env.REACT_APP_R2_WORKER_BASE || "https://forza.matteo-fbr.workers.dev"
  },
  
  // VAPID Public Key for push notifications
  vapidPublicKey: process.env.REACT_APP_VAPID_PUBLIC_KEY,

  // Agent IDs for ElevenLabs
  agentIds: {
    dashboard: process.env.REACT_APP_ELEVENLABS_DASHBOARD_AGENT_ID || 'YOUR_DASHBOARD_AGENT_ID_HERE', // TODO: Replace with actual ID
    liveCoach: process.env.REACT_APP_ELEVENLABS_LIVE_COACH_AGENT_ID || 'YOUR_LIVE_COACH_AGENT_ID_HERE'
  },
  
  ...(environment === 'development' ? {
    // Development-specific configurations
    frontendUrl: 'http://localhost:3000'
  } : {
    // Production-specific configurations
    frontendUrl: process.env.REACT_APP_FRONTEND_URL || 'https://forzalongevity.com'
  })
};

export default config;
